import Vue from 'vue'
import { getTimeFromString } from '@/helpers/dates'

Vue.filter('toTime', getTimeFromString)
